module.exports = __webpack_public_path__ + "9f3b96f28bae904a54cfab48ca0e888a.pdf";